/*
* @author 友人a丶
* @date 
* 
* */

import qs from "qs";
import {getUserInfo, login as toLogin} from "@/service/requests";
import user from "@/stores/user";
import setting from "@/stores/setting";


export default async function () {


    const query = location.href.replace(/#.*$/, "").split('?'); //切割参数
    console.log("登录的参数", query)

    /* 判断请求参数 */
    if (query.length > 1) {

        const param = qs.parse(query[1]);  // 解析URL中的查询字符串并存储到一个对象中
        const action = param.action; //登录操作


        /* 免登进入系统 */
        if (!!action && action === "login") {

            const userInfo = user();
            const sys = setting();

            /* 隐藏状态栏 */
            sys.hideMenu = true;
            sys.collapsedWidth = 0;
            sys.expandWidth = 0;

            /* 终止 */
            if (!param.user || !param.password) return;

            /* 登录的参数 */
            const data = {
                username: param.user,
                password: param.password
            };

            /* 请求登录 */
            const result = await toLogin(data);


            /*判断登录结果*/
            if (result.code) {

                /*
                * 保存token
                * */
                userInfo.setToken(result.data);

                const info = await getUserInfo(); //请求用户信息

                localStorage.setItem('username', data.username);
                localStorage.setItem('password', data.password)

                /*
                * 记录登录状态
                * */
                userInfo.save(info.user);


            }

            /* 清除密码 */
            window.history.replaceState(null, '', `${location.origin}${location.pathname}?action=login#/isle/prize/pools`); //移除code参数

        }
    }

}
